export default {"src":"/_next/static/media/help.c4686d2a.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};